
/* eslint-disable max-len */

export default `
<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_1_6)">
        <path d="M7.13573 1.48492C7.5214 0.822293 8.4786 0.822293 8.86427 1.48492L15.8557 13.497C16.2437 14.1636 15.7627 15 14.9914 15H1.00861C0.237253 15 -0.243675 14.1636 0.144342 13.497L7.13573 1.48492Z" fill="#FFAE2E"/>
        <path d="M8 6V10" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M8 12.45V12.55" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </g>
    <defs>
        <clipPath id="clip0_1_6">
        <rect width="16" height="16" fill="white"/>
        </clipPath>
    </defs>
</svg>
`
